'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherCheck, FeatherGift } from '@subframe/core';
import { Badge, Button, LogoArbitralis } from '@/shared/components/ui';
import { BONUS_ANIMACAO_MS } from '../constants';
import { useContadorAnimado, type UseOnboardingSelfReturn } from '../hooks';
interface PresenteScreenProps {
  vm: UseOnboardingSelfReturn;
}
export const PresenteScreen = t0 => {
  const $ = _c(43);
  const {
    vm
  } = t0;
  const saldo = vm.saldoPresente ?? 0;
  const bonusAnimado = useContadorAnimado(saldo, BONUS_ANIMACAO_MS);
  let t1;
  if ($[0] !== vm.produtos) {
    t1 = vm.produtos.includes("arbitragem");
    $[0] = vm.produtos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const temArbitragem = t1;
  let t2;
  if ($[2] !== vm.empresa.responsavelEmail) {
    t2 = vm.empresa.responsavelEmail.trim();
    $[2] = vm.empresa.responsavelEmail;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const emailInformado = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogoArbitralis className="flex-none [&_img]:h-6 [&_img]:w-auto" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="border-b border-solid border-neutral-200 px-6 py-6 md:px-20"><div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4">{t3}<Badge variant="success" icon={<FeatherCheck />}>Conta criada</Badge></div></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-brand-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherGift className="text-brand-600 text-[28px]" /></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== vm.primeiroNome) {
    t6 = <h1 className="text-heading-dark text-[28px] leading-tight font-semibold text-pretty sm:text-[34px]">Tudo pronto, {vm.primeiroNome}. E tem presente.</h1>;
    $[7] = vm.primeiroNome;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== vm.razaoCurta) {
    t7 = <p className="text-label-muted max-w-[520px] text-base leading-relaxed text-pretty">A conta de {vm.razaoCurta} está ativa. Você entra logado agora e confirma o e-mail depois.</p>;
    $[9] = vm.razaoCurta;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <div className="flex max-w-[620px] flex-col items-center gap-4 text-center">{t5}{t6}{t7}</div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Badge variant="brand">Já está na sua conta</Badge>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== saldo) {
    t10 = saldo.toLocaleString("pt-BR");
    $[15] = saldo;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `${t10} notificações`;
  let t12;
  if ($[17] !== bonusAnimado) {
    t12 = bonusAnimado.toLocaleString("pt-BR");
    $[17] = bonusAnimado;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <span className="text-heading-dark text-[56px] leading-none font-bold tracking-tight tabular-nums" aria-label={t11}>{t12}</span>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-label-muted pb-2 text-base font-medium">notificações</span>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13) {
    t15 = <div className="flex items-end gap-2">{t13}{t14}</div>;
    $[23] = t13;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="text-heading-dark text-[15px] font-semibold">Notificações extrajudiciais liberadas, de graça</span>;
    t17 = <span className="text-label-muted text-[13.5px] leading-relaxed">E-mail, WhatsApp e certificado de envio incluídos. Sem cartão, sem prazo de expiração escondido.</span>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t16 = $[25];
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t15) {
    t18 = <div className="mt-10 flex w-full max-w-[920px] justify-center"><div className="border-brand-600 bg-brand-50 flex w-full max-w-[460px] flex-col gap-4 rounded-[16px] border-2 border-solid p-7 shadow-md">{t9}{t15}{t16}{t17}</div></div>;
    $[27] = t15;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== temArbitragem || $[30] !== vm.produtosEscolhidos) {
    t19 = vm.produtosEscolhidos.length > 0 && <div className="mt-8 flex w-full max-w-[920px] flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 bg-neutral-50 px-6 py-5"><span className="text-[11px] font-bold tracking-[0.08em] text-neutral-500 uppercase">O que você escolheu</span><div className="flex flex-wrap gap-2.5">{vm.produtosEscolhidos.map(_temp)}</div><span className="text-[13px] leading-relaxed text-neutral-600">{temArbitragem ? "Arbitragem digital \xE9 cobrada por uso, ent\xE3o n\xE3o tem mensalidade. Os outros produtos ficam liberados para voc\xEA conhecer antes de escolher plano." : "Os produtos escolhidos ficam liberados para voc\xEA conhecer antes de escolher plano."}</span></div>;
    $[29] = temArbitragem;
    $[30] = vm.produtosEscolhidos;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FeatherArrowRight />;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== vm.entrarNaPlataforma) {
    t21 = <Button size="x-large" className="mt-10 text-base shadow-md" iconRight={t20} onClick={vm.entrarNaPlataforma}>Entrar na plataforma</Button>;
    $[33] = vm.entrarNaPlataforma;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== emailInformado) {
    t22 = emailInformado && <span className="mt-3 text-[13px] text-neutral-500">Enviamos um link de confirmação para {emailInformado}</span>;
    $[35] = emailInformado;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t18 || $[38] !== t19 || $[39] !== t21 || $[40] !== t22 || $[41] !== t8) {
    t23 = <div className="flex min-h-screen w-full flex-col bg-white">{t4}<div className="os-rise-in flex flex-1 flex-col items-center px-6 py-12 md:px-20 md:py-16">{t8}{t18}{t19}{t21}{t22}</div></div>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t21;
    $[40] = t22;
    $[41] = t8;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
};
function _temp(produto) {
  return <span key={produto.id} className="flex h-8 items-center gap-2 rounded-full border border-solid border-neutral-200 bg-white px-3.5 text-[13px] font-medium text-neutral-800"><FeatherCheck className="text-success-700 text-sm" />{produto.titulo}</span>;
}